import { render, staticRenderFns } from "./OrderInformationAddressColumn.vue?vue&type=template&id=5e63b77e"
import script from "./OrderInformationAddressColumn.vue?vue&type=script&lang=ts"
export * from "./OrderInformationAddressColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports